export const UNKNOWN_PAGE = 1;
export const TAKINGFNOL_PAGE = 2;
export const TAKINGFNOLSUBMIT_PAGE = 3;
